import React from "react"
import Poi from "./card"

import grid from "../grid.module.css"

const PoisGrid = ({ pois, hideReadMore }) => (
  <div className={grid.autofill}>
    {pois.map(poi => (
      <Poi hideReadMore={hideReadMore} {...poi} />
    ))}
  </div>
)

PoisGrid.propTypes = {}

PoisGrid.defaultProps = {}

export default PoisGrid
